<template>
  <div class="announcement-bubble">
    <BubbleHeader>{{message.message_description}}</BubbleHeader>
    <BubbleTextRow v-if="message.text"><BubbleTextMsg :text="message.text" /></BubbleTextRow>

    <a @click.stop="linkClick" class="announcement-link"> {{announcement.button_text}}</a>
  </div>
</template>

<script>
import {
  BubbleHeader,
  BubbleTextRow,
  BubbleTextMsg,
  MsgblContent,
  MsgblTextRow,
  MsgblLinkHeader,
  MsgblActions,
  MsgblTextLabel,
  MsgblTextValue,
} from './helpers'

export default {
    name: 'AnnouncementBubble',
    props: {
      message: {
        type: Object,
        required: true,
      },
    },
    components: {
      BubbleHeader,
      BubbleTextRow,
      BubbleTextMsg,
      MsgblContent,
      MsgblTextRow,
      MsgblLinkHeader,
      MsgblActions,
      MsgblTextLabel,
      MsgblTextValue,
    },
    computed: {
      announcement() {
        return this.message.messageable
      }
    },
    methods: {
      doAction(action, options) {
        this.$frontageApi.send('announcement-bubble-action', {action, options})
      },
      linkClick() {
        if (this.announcement.button_url)
          this.doAction('livesite-open-popup', {url: this.announcement.button_url})
        else {
          let options = null
          switch (this.announcement.announcement_type) {
            case 'add_client', 'livesite':
              options = {name: 'livesite'}
              break
            case 'appointment':
              options = {name: 'schedule'}
              break
            case 'payment':
              options = {name: 'pay'}
              break
            case 'document':
              options = {name: 'document'}
              break
            default:
              options = {name: 'livesite'}
          }
          
          this.doAction('livesite-redirect', options)
        }
      }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/abstract/_variables';

.announcement-bubble {
  .announcement-link {
    display:inline-block;
    margin-top: 10px;
    color: $addToListColor;
    font-weight: 600;
    font-size: 12px;
    text-decoration: underline;
  }
}
</style>